import { render, staticRenderFns } from "./CoTwoGroupTransportationForm.vue?vue&type=template&id=281d0164&"
import script from "./CoTwoGroupTransportationForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoGroupTransportationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('281d0164')) {
      api.createRecord('281d0164', component.options)
    } else {
      api.reload('281d0164', component.options)
    }
    module.hot.accept("./CoTwoGroupTransportationForm.vue?vue&type=template&id=281d0164&", function () {
      api.rerender('281d0164', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/form/CoTwoGroupTransportationForm.vue"
export default component.exports